import { fg_busy } from "@clockwise/design-system/tokens";
import { CheckCircleFilled, Warning } from "@clockwise/icons";
import classNames from "classnames";
import React from "react";

type Props = {
  sentiment: "default" | "info" | "warning";
};

export const Message: React.FC<Props> = ({ children, sentiment }) => {
  return (
    <div
      className={classNames(
        "cw-border cw-border-solid cw-rounded",
        "cw-px-2 cw-py-1.5",
        "cw-body-base",
        sentiment === "warning" ? "cw-text-warning" : "cw-text-subtle",
        "cw-border-transparent",
        "cw-bg-neutral",
        "cw-cursor-default",
      )}
    >
      <div className="cw-w-full cw-flex cw-flex-row cw-items-center cw-justify-between cw-font-normal cw-text-13 cw-leading-6">
        <>
          <div className="cw-grow cw-text-left cw-font-medium">
            <div className="cw-flex cw-flex-row cw-space-x-1 cw-items-start">
              {sentiment === "info" ? (
                <div className="cw-relative cw-top-[3px]">
                  <CheckCircleFilled fill={fg_busy} style={{ fontSize: 16 }} />
                </div>
              ) : sentiment === "warning" ? (
                <div className="cw-relative cw-top-[3px]">
                  <Warning fill={fg_busy} style={{ fontSize: 16 }} />
                </div>
              ) : null}
              <div style={{ textWrap: "wrap" }}>{children}</div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};
